import { render, staticRenderFns } from "./dictionaries-table.vue?vue&type=template&id=4b0f9872&"
import script from "./dictionaries-table.vue?vue&type=script&lang=js&"
export * from "./dictionaries-table.vue?vue&type=script&lang=js&"
import style0 from "./dictionaries-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports